<div class="flex-column menu-container">
  <div class="toggle-row">
    <span mat-dialog-title> {{ _data.title }}</span>
    <button mat-icon-button class="close-icon" (click)="close()">
      <span class="material-symbols-outlined">close</span>
    </button>
  </div>
  <mat-divider />
  @let content = _data.subtitle;
  @let subContent = _data.subtitleBottom;
  <mat-dialog-content>
    <div 
      class="upload-box scroll-Container"
      (dragover)="dragOver($event)"
      (drop)="dropOver($event)"
      (dragenter)="dragEnter($event)"
      (dragleave)="dragLeave($event)"
    >
      <!-- <button mat-raised-button [matMenuTriggerFor]="uploadMenu">{{'menuOption'}}</button> -->
      @if(selectedFiles().length === 0) {
      <div class="center-align-content">
        <div class="upload-icon">
          <span class="material-symbols-outlined">cloud_upload</span>
        </div>
        <mat-dialog-content class="content-box">{{ content ?? '' }}
          <span class="clickable-link" role="button" tabindex="0" (click)="fileInput.click()" (keyup.enter)="fileInput.click()">{{ 'clickHere' | translate }}</span>
          <span>{{ 'selectFileFromDevice' | translate}}</span>
        </mat-dialog-content>
        <mat-dialog-content class="sub-content-box">{{ subContent ?? '' }}</mat-dialog-content>
      </div>
    } @else {
      <div class="upload-icon">
        <span class="material-symbols-outlined">cloud_upload</span>
      </div>
      <mat-dialog-content class="content-box">{{ content ?? '' }}
        <span class="clickable-link" role="button" tabindex="0" (click)="fileInput.click()" (keyup.enter)="fileInput.click()">{{ 'clickHere' | translate }}</span>
        <span>{{ 'selectFileFromDevice' | translate }}</span>
      </mat-dialog-content>
      <mat-dialog-content class="sub-content-box">{{ subContent ?? '' }}</mat-dialog-content>
    }
    <!-- Single hidden input for files only - drag and drop handles both files and folders -->
    <input type="file" multiple (change)="filesPicked($event)" #fileInput hidden />
      @if (displayItems().length > 0) {
        <div>
          <table class="file-table">
            <thead>
              <tr>
                <th>{{ 'name' | translate}}</th>
                <th>{{ 'size' |translate}}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (item of displayItems(); track item.name + '-' + item.size + '-' + item.isFolder) {
                <tr>
                  <td>
                    @if (item.isFolder) {
                      <span class="material-symbols-outlined folder-icon">folder</span>
                    } @else {
                      <span class="material-symbols-outlined file-icon">description</span>
                    }
                    {{ item.name }}
                    @if (item.isFolder) {
                      <span class="file-count">({{ item.files.length }} {{ 'files' | translate }})</span>
                    }
                  </td>
                  <td>{{ item.size / 1024 / 1024 | number: '1.0-2' }} MB</td>
                  <td>
                    <button mat-icon-button (click)="removeItem(item)" class="button-height">
                      <span class="material-symbols-outlined icon-size">delete</span>
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-flat-button class="secondary-button" [mat-dialog-close]>
      {{ 'cancel' | translate}}
    </button>
    <button
      mat-flat-button
      class="button-field"
      (click)="uploadFiles()"
      [disabled]="uploading() || selectedFiles().length === 0"
    >
      {{ 'upload' | translate}}
    </button>
  </mat-dialog-actions>
</div>

